import { AbstractControl, ValidationErrors } from '@angular/forms';

export const namesValidator = (control: AbstractControl): ValidationErrors | null => {
  let code;
  const codeValue = control.value;
  const codeArray = [];
  if (codeValue && codeValue !== null) {
    codeArray.push(codeValue);
    for (const val of codeArray[0]) {
      code = val.length;
    }
  }
  if (!code) {
    return null;
  }
  if (code < 1 || code > 30) {
    return {
      namesValidator: {
        requiredValue: 30
      }
    };
  }
  return null;
};
